import { render, staticRenderFns } from "./explainList.vue?vue&type=template&id=277c4258&scoped=true"
import script from "./explainList.vue?vue&type=script&lang=js"
export * from "./explainList.vue?vue&type=script&lang=js"
import style0 from "./explainList.vue?vue&type=style&index=0&id=277c4258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c4258",
  null
  
)

export default component.exports